import { connect } from 'react-redux'

import { setDirtyFlag, toggleFlexDates } from '../../actions/index'
import FlexDatesOptionsCheckbox from './FlexDatesOptionsCheckbox'

export const mapStateToProps = (state, ownProps) => ({
  tripType: state.tripType,
  isFlexDates: state.flexDates,
  isDirty: state.formUI.isDirty,
  setCheckboxRef: ownProps.setCheckboxRef,
})

export const mapDispatchToProps = {
  setDirtyFlag,
  toggleFlexDates,
}

const FlexDatesCheckbox = connect(mapStateToProps, mapDispatchToProps)(FlexDatesOptionsCheckbox)

export default FlexDatesCheckbox
